import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import '../../styles/styles.scss';
import styles from './SliderReviews.module.scss';
import {getBaseImagePath} from '../../../../ui/catalog/Utils';
import {Autoplay, Pagination} from 'swiper/modules';

const SliderReviews = (props) => {
	const slides = props.params.sliderReview || [];

	return (
		<>
			<div className={styles.carouselContainer}>
				<Swiper
					grabCursor={true}
					centeredSlides={false}
					slidesPerView={1}
					loop={true}
					speed={400}
					spaceBetween={0}
					modules={[Autoplay, Pagination]}
					pagination={{
						clickable: true,
						el: '.bullet-pag',
						renderBullet: function(index, className) {
							return `<span class="${className} bullet-pag-elem"></span>`;
						},
					}}
					autoplay={{
						delay: 5000,
					}}
				>
					{slides.map((slide, i) => (
						<SwiperSlide key={i} className={styles.slideContainer}>
							<div className={styles.textBlock}>
								<p
									className={styles.reviewText}
									dangerouslySetInnerHTML={{__html: slide.text}}
								></p>

							</div>
							<div className={styles.imageContainer}>
								<a href={slide.url}>
									<img
										className={styles.slideImage}
										src={getBaseImagePath() + slide.img}
										alt={slide.img}
									/>
								</a>
							</div>
							<p className={styles.author}>{slide.title}</p>
						</SwiperSlide>
					))}
					<div className="bullet-pag"></div>
				</Swiper>
			</div>
		</>
	);
};

export default SliderReviews;